package nl.volleyplanner.nevoboservice.api

import io.ktor.client.engine.js.*
import io.ktor.client.plugins.logging.*
import okio.FileSystem
import okio.Path
import okio.fakefilesystem.FakeFileSystem

/**
 * TODO: Support for okio in JS. Need different libraries for browser and Node
 * Kotlin doesn't properly support multiple JS targets yet:
 *  see: https://youtrack.jetbrains.com/issue/KT-47038/KJS-MPP-Split-JS-target-into-JsBrowser-and-JsNode
 *
 * As we're not actively using this API in JS yet, leave it be for now
 */
actual val mockDirectoryPath: Path
    get() = TODO("Not yet implemented")
actual val mockFileSystem: FileSystem = FakeFileSystem()
actual val apiHttpEngine = Js.create()
actual val ktorLoggingEnabled = false
actual val ktorLogger = Logger.SIMPLE
